import Components from "slotworks/components/components";
import Translations from "slotworks/i18n/translations";
import Contract from "slotworks/utils/contract";

export function InfoCommand(messageId: string, sceneNames: string[] = ["info", "error"], button: string[] = [], data?: any): Contract<void> {

    let message;

    try {
        message = Translations.get(messageId);
    } catch (e) {
        message = messageId;
    }

    if (message === undefined || message === "" || !message) {
        message = Translations.get("@err_server_generic");
    }

    const contents = new Map<any , any>();
    contents.set("body", message);
    contents.set("button", button);
    contents.set("data", data);

    return Components.prompt.show(sceneNames, contents);
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/error/info-command.ts